import React, { useState } from "react";
import Card from "../ui/Card";
import Button from "../ui/Button";
import ScoreBadge from "./ScoreBadge";

import SourceBadges from "../common/badge/SourceBadges"
import IntentBadge from "../common/badge/IntentBadge";

import { Send } from "lucide-react";

import "../../styles/leads.css";

function LeadCard({ lead, handleResend }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="lead-card  m-0">
      {/* Header */}

      <div className="lead-card-header">
        <h4 className="lead-name">{lead.name}</h4>

        <ScoreBadge score={lead.score} />
      </div>

      {/* Primary Info */}

      <div className="lead-primary">
        <div className="lead-row">
          <span className="label">Phone</span>
          <span>{lead.phone}</span>
        </div>

        <div className="lead-row">
          <span className="label">Property</span>
          <span className="badge badge-property">{lead.property}</span>
        </div>

        <div className="lead-row">
          <span className="label">Category</span>
          <span className={`badge badge-${lead.category.toLowerCase()}`}>
            {lead.category}
          </span>
        </div>
      </div>

      {/* Expand Button */}

      <div className="lead-action">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Hide Details" : "View More"}
        </Button>
      </div>

      {/* Expanded Content */}

      {expanded && (
        <div className="lead-expanded">
          <div className="lead-row">
            <span className="label">Client</span>
            <span>{lead.clientName}</span>
          </div>

          <div className="lead-row">
            <span className="label">Email</span>
            <span>{lead.email}</span>
          </div>

          <div className="lead-row">
            <span className="label">Source</span>
             <SourceBadges sources={lead.sources} />
          </div>

          <div className="lead-row">
            <span className="label">Session In</span>
            <span>{lead.sessionIn}</span>
          </div>

          <div className="lead-row">
            <span className="label">Session Out</span>
            <span>{lead.sessionOut}</span>
          </div>

          <div className="lead-row">
            <span className="label">Budget</span>
            <span>{lead.budget}</span>
          </div>

          <div className="lead-row">
            <span className="label">Timeline</span>
            <span>{lead.timeline}</span>
          </div>

          <div className="lead-row">
            <span className="label">Brochure</span>
            <span>{lead.brochure_status}</span>
          </div>

          <div className="lead-row">
            <span className="label">Intent</span>
            <IntentBadge intent={lead.intent} />
          </div>

          <div className="lead-summary">
            <strong>Lead Summary</strong>

            <p style={{ whiteSpace: "pre-line" }}>{lead.summary}</p>
          </div>

          <div className="lead-card-footer">
            <Button className="gap-2" onClick={() => handleResend?.(lead)}>
              <Send size={16} className="gap-2" />
              Resend Lead
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
}

export default LeadCard;
